(function () {
  var lastToastAt = 0;
  var klaviyoReviewSummaryCache = {};
  var klaviyoProductRatingsCache = {};
  var klaviyoProductRatingsRequestCache = {};
  var tallOwlRotatingScentIndexCache = {};
  var tallOwlBogoProductCache = {};
  var tallOwlBogoResolvedFreeHandleCache = {};
  var TALL_OWL_BOGO_GIFT_VARIANT_CACHE_KEY = 'tall_owl_bogo_gift_variant_cache_v1';
  var tallOwlBogoResolvedGiftVariantCache = {};
  var tallOwlBogoPopupTimer = null;
  var tallOwlBogoController = null;
  var suppressNextAddToCartToast = false;
  var checkoutSyncLocked = false;

  function normalizeHeroVariant(value) {
    var token = String(value || '')
      .trim()
      .toLowerCase();
    if (!token) return '';
    if (token === 'current' || token === 'new' || token === 'control' || token === 'a') return 'current';
    if (token === 'old' || token === 'legacy' || token === 'old_image' || token === 'variant_b' || token === 'b') return 'old_image';
    return '';
  }

  function normalizeHeroMode(value) {
    var token = String(value || '')
      .trim()
      .toLowerCase();
    if (!token) return '';
    if (token === 'old' || token === 'legacy' || token === 'old_image') return 'old_image';
    if (token === 'ab' || token === 'ab-test' || token === 'ab_test' || token === 'experiment') return 'ab_test';
    if (token === 'current' || token === 'new' || token === 'control') return 'current';
    return '';
  }

  function getQueryParam(name) {
    if (!window.location || !window.location.search) return '';
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch (error) {
      var pattern = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
      var match = window.location.search.match(pattern);
      return match && match[1] ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }
  }

  function isTruthyToken(value) {
    var token = String(value || '')
      .trim()
      .toLowerCase();
    return token === '1' || token === 'true' || token === 'on' || token === 'yes';
  }

  function readStorageValue(storage, key) {
    if (!storage) return '';
    try {
      return storage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeStorageValue(storage, key, value) {
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* Ignore storage write issues */
    }
  }

  function loadBogoGiftVariantCache() {
    var raw = readStorageValue(window.sessionStorage, TALL_OWL_BOGO_GIFT_VARIANT_CACHE_KEY);
    if (!raw) return {};

    try {
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return {};

      var normalized = {};
      Object.keys(parsed).forEach(function (key) {
        var value = Number(parsed[key]);
        if (!Number.isFinite(value) || value <= 0) return;
        normalized[key] = Math.round(value);
      });
      return normalized;
    } catch (error) {
      return {};
    }
  }

  function persistBogoGiftVariantCache() {
    writeStorageValue(
      window.sessionStorage,
      TALL_OWL_BOGO_GIFT_VARIANT_CACHE_KEY,
      JSON.stringify(tallOwlBogoResolvedGiftVariantCache)
    );
  }

  tallOwlBogoResolvedGiftVariantCache = loadBogoGiftVariantCache();

  function shouldEnableGaDebugMode() {
    var storageKey = 'tall_owl_ga_debug';
    var queryValue = String(getQueryParam('ga_debug') || '').trim();
    if (queryValue) {
      var enabledFromQuery = isTruthyToken(queryValue);
      writeStorageValue(window.sessionStorage, storageKey, enabledFromQuery ? '1' : '0');
      return enabledFromQuery;
    }
    return readStorageValue(window.sessionStorage, storageKey) === '1';
  }

  var gaDebugModeEnabled = shouldEnableGaDebugMode();

  function createHeroSessionId() {
    return 'tos-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getHeroSessionId() {
    var sessionKey = 'tall_owl_session_id';
    var existing =
      String(window.tallOwlSessionId || '').trim() ||
      String(document.documentElement.getAttribute('data-tall-owl-session-id') || '').trim() ||
      String(readStorageValue(window.sessionStorage, sessionKey) || '').trim();

    if (!existing) {
      existing = createHeroSessionId();
      writeStorageValue(window.sessionStorage, sessionKey, existing);
    }

    window.tallOwlSessionId = existing;
    document.documentElement.setAttribute('data-tall-owl-session-id', existing);
    return existing;
  }

  function getActiveHeroVariant() {
    var variantFromDataset = normalizeHeroVariant(document.documentElement.getAttribute('data-tall-owl-hero-variant'));
    if (variantFromDataset) return variantFromDataset;

    var variantFromWindow = normalizeHeroVariant(window.tallOwlHeroExperiment && window.tallOwlHeroExperiment.variant);
    if (variantFromWindow) return variantFromWindow;

    var variantFromStorage = normalizeHeroVariant(
      readStorageValue(window.localStorage, 'tall_owl_hero_variant') || readStorageValue(window.sessionStorage, 'tall_owl_hero_variant')
    );
    if (variantFromStorage) return variantFromStorage;

    var legacyStorageVariant = normalizeHeroVariant(
      readStorageValue(window.localStorage, 'tallOwlHeroVariant') || readStorageValue(window.sessionStorage, 'tallOwlHeroVariant')
    );
    if (legacyStorageVariant) return legacyStorageVariant;

    return '';
  }

  function getActiveHeroMode() {
    var modeFromDataset = normalizeHeroMode(document.documentElement.getAttribute('data-tall-owl-hero-mode'));
    if (modeFromDataset) return modeFromDataset;

    var modeFromWindow = normalizeHeroMode(window.tallOwlHeroExperiment && window.tallOwlHeroExperiment.mode);
    if (modeFromWindow) return modeFromWindow;

    var modeFromStorage = normalizeHeroMode(
      readStorageValue(window.localStorage, 'tall_owl_hero_variant_mode') ||
        readStorageValue(window.sessionStorage, 'tall_owl_hero_variant_mode') ||
        readStorageValue(window.localStorage, 'tallOwlHeroVariantMode') ||
        readStorageValue(window.sessionStorage, 'tallOwlHeroVariantMode')
    );
    if (modeFromStorage) return modeFromStorage;

    return '';
  }

  function clonePayload(payload) {
    var data = {};
    if (!payload || typeof payload !== 'object') return data;
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        data[key] = payload[key];
      }
    }
    return data;
  }

  function pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = clonePayload(payload);

    if (!data.hero_variant) {
      var heroVariant = getActiveHeroVariant();
      if (heroVariant) {
        data.hero_variant = heroVariant;
      }
    }

    if (!data.hero_mode) {
      var heroMode = getActiveHeroMode();
      if (heroMode) {
        data.hero_mode = heroMode;
      }
    }

    if (!data.hero_session_id) {
      var heroSessionId = getHeroSessionId();
      if (heroSessionId) {
        data.hero_session_id = heroSessionId;
      }
    }

    if (gaDebugModeEnabled && data.debug_mode == null) {
      data.debug_mode = true;
    }

    data.event = eventName;
    window.dataLayer.push(data);
  }

  function getReviewSummaryCompanyId(companyId) {
    var trimmed = String(companyId || '').trim();
    return trimmed || 'UJMPJV';
  }

  function buildReviewSummaryUrl(companyId, subtype) {
    var params = new URLSearchParams();
    params.set('product_id', 'all');
    params.set('company_id', companyId);
    params.set('limit', '1');
    params.set('offset', '0');
    params.set('sort', '0');
    params.set('filter', '');
    params.set('type', 'reviews');
    params.set('media', 'false');
    if (subtype) params.set('subtype', subtype);
    return 'https://fast.a.klaviyo.com/reviews/api/client_reviews/all/?' + params.toString();
  }

  async function fetchSummaryPart(companyId, subtype) {
    var response = await fetch(buildReviewSummaryUrl(companyId, subtype), { method: 'GET' });
    if (!response.ok) throw new Error('Failed to fetch Klaviyo review summary');
    var payload = await response.json();
    var summary = payload && payload.summary ? payload.summary : null;
    if (!summary) return null;

    var count = Number(summary.review_count);
    var rating = Number(summary.star_rating);
    if (!Number.isFinite(count) || count <= 0 || !Number.isFinite(rating)) return null;

    return {
      count: Math.round(count),
      rating: rating
    };
  }

  function combineSummaryParts(parts) {
    var valid = (parts || []).filter(function (part) {
      return part && part.count > 0;
    });
    if (!valid.length) return null;

    var totalCount = 0;
    var weightedRatingTotal = 0;
    valid.forEach(function (part) {
      totalCount += part.count;
      weightedRatingTotal += part.rating * part.count;
    });
    if (!totalCount) return null;

    return {
      count: totalCount,
      rating: weightedRatingTotal / totalCount
    };
  }

  function getSharedKlaviyoReviewSummary(companyId) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    if (klaviyoReviewSummaryCache[safeCompanyId]) {
      return klaviyoReviewSummaryCache[safeCompanyId];
    }

    klaviyoReviewSummaryCache[safeCompanyId] = Promise.all([
      fetchSummaryPart(safeCompanyId, ''),
      fetchSummaryPart(safeCompanyId, 'store')
    ])
      .then(function (parts) {
        return combineSummaryParts(parts);
      })
      .catch(function (error) {
        delete klaviyoReviewSummaryCache[safeCompanyId];
        throw error;
      });

    return klaviyoReviewSummaryCache[safeCompanyId];
  }

  function getCompanyRatingsCache(companyId) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    if (!klaviyoProductRatingsCache[safeCompanyId]) {
      klaviyoProductRatingsCache[safeCompanyId] = {};
    }
    return klaviyoProductRatingsCache[safeCompanyId];
  }

  function getRequestCacheKey(companyId, productIds) {
    return getReviewSummaryCompanyId(companyId) + '::' + productIds.slice().sort().join(',');
  }

  function fetchKlaviyoProductRatings(companyId, productIds) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    var uniqueIds = Array.from(
      new Set(
        (productIds || [])
          .map(function (id) {
            return String(id || '').trim();
          })
          .filter(function (id) {
            return id.length > 0;
          })
      )
    );
    if (!uniqueIds.length) return Promise.resolve({});

    var companyCache = getCompanyRatingsCache(safeCompanyId);
    var missingIds = uniqueIds.filter(function (id) {
      return !Object.prototype.hasOwnProperty.call(companyCache, id);
    });

    function buildResult() {
      var result = {};
      uniqueIds.forEach(function (id) {
        if (Object.prototype.hasOwnProperty.call(companyCache, id)) {
          result[id] = companyCache[id];
        }
      });
      return result;
    }

    if (!missingIds.length) {
      return Promise.resolve(buildResult());
    }

    var requestKey = getRequestCacheKey(safeCompanyId, missingIds);
    if (!klaviyoProductRatingsRequestCache[requestKey]) {
      var params = new URLSearchParams();
      params.set('company_id', safeCompanyId);
      params.set('products', JSON.stringify(missingIds));

      klaviyoProductRatingsRequestCache[requestKey] = fetch(
        'https://fast.a.klaviyo.com/reviews/api/client_reviews/?' + params.toString(),
        { method: 'GET' }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load Klaviyo product ratings');
          return response.json();
        })
        .then(function (payload) {
          var products = payload && Array.isArray(payload.products) ? payload.products : [];
          var found = {};

          products.forEach(function (product) {
            if (!product || product.shopify_id == null) return;
            var id = String(product.shopify_id);
            var rating = Number(product.star_rating);
            var count = Number(product.review_count);
            if (!Number.isFinite(rating)) return;

            found[id] = true;
            companyCache[id] = {
              rating: Math.round(rating * 10) / 10,
              count: Number.isFinite(count) && count > 0 ? Math.round(count) : 0
            };
          });

          missingIds.forEach(function (id) {
            if (!found[id]) {
              companyCache[id] = null;
            }
          });
        })
        .finally(function () {
          delete klaviyoProductRatingsRequestCache[requestKey];
        });
    }

    return klaviyoProductRatingsRequestCache[requestKey].then(function () {
      return buildResult();
    });
  }

  window.tallOwlReviews = window.tallOwlReviews || {};
  window.tallOwlReviews.getSummary = getSharedKlaviyoReviewSummary;
  window.tallOwlReviews.getProductRatings = fetchKlaviyoProductRatings;
  window.dispatchEvent(new CustomEvent('tallowl:reviews-helper-ready'));

  function collectGridRatingElements(scope) {
    var elements = [];
    if (!scope) return elements;

    if (scope.nodeType === 1 && scope.matches('[data-klaviyo-grid-rating][data-klaviyo-product-id]')) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements = elements.concat(
        Array.prototype.slice.call(scope.querySelectorAll('[data-klaviyo-grid-rating][data-klaviyo-product-id]'))
      );
    }

    return elements;
  }

  function applyGridRating(el, ratingData) {
    var valueEl = el.querySelector('.tall-owl-grid-rating__value');
    var countEl = el.querySelector('.tall-owl-grid-rating__count');
    if (!valueEl || !countEl || !ratingData) return;

    var normalizedRating = (Math.round(Number(ratingData.rating) * 10) / 10).toFixed(1);
    var safeCount = Number(ratingData.count);
    var formattedCount = Number.isFinite(safeCount) && safeCount > 0 ? Math.round(safeCount).toLocaleString() : '';

    valueEl.textContent = normalizedRating;
    countEl.textContent = formattedCount ? '(' + formattedCount + ')' : '';

    var ariaLabel = formattedCount
      ? 'Rated ' + normalizedRating + ' out of 5 from ' + formattedCount + ' reviews'
      : 'Rated ' + normalizedRating + ' out of 5';
    el.setAttribute('aria-label', ariaLabel);
  }

  function initCollectionGridRatings(scope) {
    if (!document.body.classList.contains('template-collection')) return;

    var root = scope || document;
    var ratingEls = collectGridRatingElements(root).filter(function (el) {
      return el.getAttribute('data-klaviyo-grid-rating-ready') !== 'true';
    });
    if (!ratingEls.length) return;

    var companyId = 'UJMPJV';
    for (var i = 0; i < ratingEls.length; i += 1) {
      var configuredCompanyId = (ratingEls[i].getAttribute('data-klaviyo-company-id') || '').trim();
      if (configuredCompanyId) {
        companyId = configuredCompanyId;
        break;
      }
    }

    var productIds = ratingEls
      .map(function (el) {
        return (el.getAttribute('data-klaviyo-product-id') || '').trim();
      })
      .filter(function (id) {
        return id.length > 0;
      });
    if (!productIds.length) return;

    fetchKlaviyoProductRatings(companyId, productIds)
      .then(function (ratingsById) {
        ratingEls.forEach(function (el) {
          var productId = (el.getAttribute('data-klaviyo-product-id') || '').trim();
          if (productId && ratingsById && ratingsById[productId]) {
            applyGridRating(el, ratingsById[productId]);
          }
          el.setAttribute('data-klaviyo-grid-rating-ready', 'true');
        });
      })
      .catch(function () {
        ratingEls.forEach(function (el) {
          el.setAttribute('data-klaviyo-grid-rating-ready', 'true');
        });
      });
  }

  function initCollectionGridRatingsObserver() {
    if (!document.body.classList.contains('template-collection') || !window.MutationObserver) return;
    var container = document.getElementById('CollectionAjaxContent') || document.getElementById('MainContent');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          initCollectionGridRatings(node);
          initRotatingScentCards(node);
        });
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function collectVariantDescriptionBlocks(scope) {
    var blocks = [];
    if (!scope) return blocks;

    if (scope.nodeType === 1 && scope.matches('[data-variant-description-block]')) {
      blocks.push(scope);
    }

    if (scope.querySelectorAll) {
      blocks = blocks.concat(
        Array.prototype.slice.call(scope.querySelectorAll('[data-variant-description-block]'))
      );
    }

    return blocks;
  }

  function getCurrentVariantIdForSection(productSection) {
    if (!productSection || !productSection.querySelector) return '';
    var currentVariantNode = productSection.querySelector('[data-current-variant-json]');
    if (!currentVariantNode) return '';

    var currentVariant = parseJsonData((currentVariantNode.textContent || '').trim());
    if (!currentVariant || currentVariant.id == null) return '';
    return String(currentVariant.id);
  }

  function renderVariantDescriptionForVariant(block, variantId) {
    if (!block || !block.querySelector) return;

    var output = block.querySelector('[data-variant-description-output]');
    if (!output) return;

    var map = block._tallOwlVariantDescriptionMap || {};
    var optionOneMap = block._tallOwlVariantDescriptionOptionOneMap || {};
    var variantOptionOneMap = block._tallOwlVariantDescriptionVariantOptionOneMap || {};
    var productFallbackHtml = block._tallOwlVariantDescriptionProductFallbackHtml || '';
    var fallbackHtml = block._tallOwlVariantDescriptionFallbackHtml || '';
    var variantKey = variantId == null ? '' : String(variantId);
    var nextHtml = '';
    var optionOneKey = '';

    if (variantKey && Object.prototype.hasOwnProperty.call(map, variantKey)) {
      nextHtml = map[variantKey] || '';
    }

    if (!nextHtml && variantKey && Object.prototype.hasOwnProperty.call(variantOptionOneMap, variantKey)) {
      optionOneKey = variantOptionOneMap[variantKey] || '';
      if (optionOneKey && Object.prototype.hasOwnProperty.call(optionOneMap, optionOneKey)) {
        nextHtml = optionOneMap[optionOneKey] || '';
      }
    }

    if (!nextHtml) {
      nextHtml = productFallbackHtml;
    }

    if (!nextHtml) {
      nextHtml = fallbackHtml;
    }

    output.innerHTML = nextHtml || '';

    var isEmpty = !(nextHtml && String(nextHtml).replace(/\s+/g, '').length);
    if (isEmpty) {
      block.setAttribute('data-variant-description-empty', 'true');
    } else {
      block.removeAttribute('data-variant-description-empty');
    }
  }

  function initVariantDescriptionBlocks(scope) {
    var blocks = collectVariantDescriptionBlocks(scope);
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      if (block.getAttribute('data-variant-description-ready') === 'true') return;

      var mapNode = block.querySelector('[data-variant-description-map]');
      var optionOneMapNode = block.querySelector('[data-variant-description-option-one-map]');
      var variantOptionOneMapNode = block.querySelector('[data-variant-description-variant-option-one-map]');
      var fallbackNode = block.querySelector('template[data-variant-description-fallback]');
      var productFallbackNode = block.querySelector('template[data-variant-description-product-fallback]');
      var productSection = block.closest('.product-section');
      if (!mapNode || !productSection) return;

      var mapData = parseJsonData((mapNode.textContent || '').trim());
      var optionOneMapData = optionOneMapNode ? parseJsonData((optionOneMapNode.textContent || '').trim()) : null;
      var variantOptionOneMapData = variantOptionOneMapNode ? parseJsonData((variantOptionOneMapNode.textContent || '').trim()) : null;
      block._tallOwlVariantDescriptionMap = mapData && typeof mapData === 'object' ? mapData : {};
      block._tallOwlVariantDescriptionOptionOneMap = optionOneMapData && typeof optionOneMapData === 'object' ? optionOneMapData : {};
      block._tallOwlVariantDescriptionVariantOptionOneMap = variantOptionOneMapData && typeof variantOptionOneMapData === 'object' ? variantOptionOneMapData : {};
      block._tallOwlVariantDescriptionProductFallbackHtml = productFallbackNode ? productFallbackNode.innerHTML : '';
      block._tallOwlVariantDescriptionFallbackHtml = fallbackNode ? fallbackNode.innerHTML : '';

      var initialVariantId = (block.getAttribute('data-current-variant-id') || '').trim();
      if (!initialVariantId) {
        initialVariantId = getCurrentVariantIdForSection(productSection);
      }

      renderVariantDescriptionForVariant(block, initialVariantId);

      var onVariantChange = function (event) {
        if (!block.isConnected) {
          productSection.removeEventListener('variantChange', onVariantChange);
          return;
        }

        var variant = event && event.detail && event.detail.variant ? event.detail.variant : null;
        var variantId = variant && variant.id != null ? String(variant.id) : '';
        renderVariantDescriptionForVariant(block, variantId);
      };

      productSection.addEventListener('variantChange', onVariantChange);

      block.setAttribute('data-variant-description-ready', 'true');
    });
  }

  function initVariantDescriptionObserver() {
    if (!window.MutationObserver) return;
    var container = document.getElementById('MainContent') || document.body;
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          initVariantDescriptionBlocks(node);
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function parseJsonData(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function getSecureRandomInt(maxExclusive) {
    if (!Number.isFinite(maxExclusive) || maxExclusive <= 0) return 0;
    var max = Math.floor(maxExclusive);
    if (max <= 1) return 0;

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      return randomBuffer[0] % max;
    }

    return Math.floor(Math.random() * max);
  }

  function getRotatingScentIndex(productId, variantCount) {
    if (variantCount < 2) return 0;
    var cacheKey = productId || 'unknown';
    if (Object.prototype.hasOwnProperty.call(tallOwlRotatingScentIndexCache, cacheKey)) {
      return tallOwlRotatingScentIndexCache[cacheKey];
    }
    var randomIndex = getSecureRandomInt(variantCount);
    tallOwlRotatingScentIndexCache[cacheKey] = randomIndex;
    return randomIndex;
  }

  function updateCardImageForVariant(card, imageUrl) {
    if (!imageUrl) return;

    var primaryImage = card.querySelector(
      '.grid__item-image-wrapper .grid__image-ratio img, .grid__item-image-wrapper .image-wrap img, .tall-owl-product-card__image-link img, .tall-owl-product-card__image'
    );
    if (!primaryImage) return;

    primaryImage.setAttribute('src', imageUrl);
    primaryImage.setAttribute('srcset', imageUrl);
    primaryImage.setAttribute('data-src', imageUrl);
    primaryImage.setAttribute('data-srcset', imageUrl);
  }

  function updateCardLinksForVariant(card, variantUrl) {
    if (!variantUrl) return;
    var links = card.querySelectorAll('[data-tall-owl-random-scent-link]');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('href', variantUrl);
    });
  }

  function updateScentLabel(card, scentLabel) {
    if (!scentLabel) return;
    var note = card.querySelector('[data-tall-owl-scent-note]');
    if (!note) return;

    var scentCount = Number(note.getAttribute('data-scent-count'));
    var countText = Number.isFinite(scentCount) && scentCount > 1 ? String(Math.round(scentCount)) + ' scents' : '';
    var scentValueLabel = note.querySelector('[data-tall-owl-current-scent-value]');
    var countLabel = note.querySelector('[data-tall-owl-scent-count-label]');
    var currentLabel = note.querySelector('[data-tall-owl-current-scent-label]');
    var currentText = 'Showing ' + scentLabel;

    if (countLabel || currentLabel || scentValueLabel) {
      if (countLabel) countLabel.textContent = countText;
      if (currentLabel) currentLabel.textContent = currentText;
      if (scentValueLabel) scentValueLabel.textContent = scentLabel;

      var ariaLabel = countText ? countText + '. ' + currentText : currentText;
      note.setAttribute('aria-label', ariaLabel);
      return;
    }

    note.textContent = countText ? countText + ' • ' + currentText : currentText;
  }

  function applyRotatingScentVariant(card, variant) {
    if (!card || !variant) return;
    updateCardLinksForVariant(card, variant.url || '');
    updateCardImageForVariant(card, variant.image || '');
    updateScentLabel(card, variant.scent || '');
  }

  function initRotatingScentCards(scope) {
    var root = scope || document;
    var cards = [];

    if (root.nodeType === 1 && root.matches('[data-tall-owl-random-scent-card="true"]')) {
      cards.push(root);
    }
    if (root.querySelectorAll) {
      cards = cards.concat(
        Array.prototype.slice.call(root.querySelectorAll('[data-tall-owl-random-scent-card="true"]'))
      );
    }

    cards.forEach(function (card) {
      if (card.getAttribute('data-tall-owl-random-scent-ready') === 'true') return;

      var productId = (card.getAttribute('data-product-id') || '').trim();
      var dataNode = card.querySelector('script[data-tall-owl-random-scent-variants]');
      var variants = parseJsonData(dataNode ? dataNode.textContent : '');
      if (!Array.isArray(variants) || variants.length < 2) {
        card.setAttribute('data-tall-owl-random-scent-ready', 'true');
        return;
      }

      var selectedIndex = getRotatingScentIndex(productId || 'unknown', variants.length);
      applyRotatingScentVariant(card, variants[selectedIndex]);
      card.setAttribute('data-tall-owl-random-scent-ready', 'true');
    });
  }

  function showToast() {
    return;
  }

  function clearBogoPopupTimer() {
    if (!tallOwlBogoPopupTimer) return;
    window.clearTimeout(tallOwlBogoPopupTimer);
    tallOwlBogoPopupTimer = null;
  }

  function closeBogoAddedPopup() {
    clearBogoPopupTimer();
    var popup = document.querySelector('.tall-owl-bogo-popup');
    if (!popup) return;

    popup.classList.remove('is-visible');
    window.setTimeout(function () {
      if (popup.parentNode) popup.parentNode.removeChild(popup);
    }, 240);
  }

  function openCartFromPopup() {
    var cartType = window.theme && theme.settings ? theme.settings.cartType : '';
    if (cartType === 'drawer') {
      document.dispatchEvent(new CustomEvent('cart:open'));
      return;
    }

    var cartPage = window.theme && theme.routes && theme.routes.cartPage ? theme.routes.cartPage : '/cart';
    window.location.href = cartPage;
  }

  function buildPopupLine(label, value) {
    var row = document.createElement('p');
    row.className = 'tall-owl-bogo-popup__line';

    var labelEl = document.createElement('span');
    labelEl.className = 'tall-owl-bogo-popup__line-label';
    labelEl.textContent = label;

    var valueEl = document.createElement('span');
    valueEl.className = 'tall-owl-bogo-popup__line-value';
    valueEl.textContent = value;

    row.appendChild(labelEl);
    row.appendChild(valueEl);
    return row;
  }

  function showBogoAddedPopup(payload) {
    if (!payload) return;

    closeBogoAddedPopup();

    var popup = document.createElement('aside');
    popup.className = 'tall-owl-bogo-popup';
    popup.setAttribute('role', 'status');
    popup.setAttribute('aria-live', 'polite');

    var top = document.createElement('div');
    top.className = 'tall-owl-bogo-popup__top';

    var badge = document.createElement('span');
    badge.className = 'tall-owl-bogo-popup__badge';
    badge.textContent = 'BOGO Active';
    top.appendChild(badge);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'tall-owl-bogo-popup__close';
    closeBtn.setAttribute('aria-label', 'Close BOGO confirmation');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeBogoAddedPopup);
    top.appendChild(closeBtn);
    popup.appendChild(top);

    var title = document.createElement('p');
    title.className = 'tall-owl-bogo-popup__title';
    title.textContent = 'Free product added to your cart';
    popup.appendChild(title);

    var subtitle = document.createElement('p');
    subtitle.className = 'tall-owl-bogo-popup__subtitle';
    subtitle.textContent = 'BOGO matched the same size + variant automatically.';
    popup.appendChild(subtitle);

    if (payload.sourceTitle) {
      popup.appendChild(buildPopupLine('Purchased:', payload.sourceTitle));
    }

    if (payload.freeTitle) {
      popup.appendChild(buildPopupLine('Free item:', payload.freeTitle));
    }

    if (payload.variantLabel) {
      popup.appendChild(buildPopupLine('Matched variant:', payload.variantLabel));
    }

    var foot = document.createElement('div');
    foot.className = 'tall-owl-bogo-popup__foot';

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'tall-owl-bogo-popup__cta';
    cta.textContent = 'View Cart';
    cta.addEventListener('click', function () {
      closeBogoAddedPopup();
      openCartFromPopup();
    });
    foot.appendChild(cta);

    var note = document.createElement('span');
    note.className = 'tall-owl-bogo-popup__note';
    note.textContent = payload.totalAdded > 1 ? payload.totalAdded + ' free items added' : 'No code needed';
    foot.appendChild(note);
    popup.appendChild(foot);

    if (payload.extraLineCount > 0) {
      var extra = document.createElement('p');
      extra.className = 'tall-owl-bogo-popup__extra';
      extra.textContent = 'Plus ' + payload.extraLineCount + ' more BOGO match' + (payload.extraLineCount > 1 ? 'es' : '') + '.';
      popup.appendChild(extra);
    }

    document.body.appendChild(popup);
    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    clearBogoPopupTimer();
    tallOwlBogoPopupTimer = window.setTimeout(function () {
      closeBogoAddedPopup();
    }, 6200);
  }

  function addToCart(variantId, quantity) {
    if (!variantId) return Promise.resolve(null);
    var qty = parsePositiveInt(quantity);
    if (!qty) qty = 1;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add');
        return response.json();
      })
      .then(function (product) {
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: product, addToCartBtn: null }
          })
        );
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (error) {
        showToast('Unable to add this item right now.');
        throw error;
      });
  }

  function addPreCheckoutUpsellToCart(variantId, quantity) {
    if (!variantId) return Promise.reject(new Error('Missing variant'));
    var qty = parsePositiveInt(quantity);
    if (!qty) qty = 1;

    var cartAddUrl = window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add.js';
    return postCartJson(cartAddUrl, {
      id: Number(variantId),
      quantity: qty
    })
      .then(function (lineItem) {
        return fetchCartJson().then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            })
          );
          document.dispatchEvent(new CustomEvent('cart:build'));
          return {
            lineItem: lineItem,
            cart: cart
          };
        });
      })
      .catch(function (error) {
        showToast('Unable to add this offer right now.');
        throw error;
      });
  }

  function formatThemeMoney(cents) {
    var amount = parsePositiveInt(cents);
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function createPreCheckoutUpsellController(beforeCheckoutSubmit) {
    var modalId = 'PreCheckoutUpsellModal';
    var modalElement = document.getElementById(modalId);
    if (!modalElement) return null;

    var modalInstance = window.theme && theme.Modals ? new theme.Modals(modalId, 'pre-checkout-upsell-modal', { closeOffContentClick: false }) : null;
    var continueButton = modalElement.querySelector('[data-pre-checkout-upsell-continue]');
    var timerElement = modalElement.querySelector('[data-pre-checkout-upsell-timer]');
    var countdownSeconds = parsePositiveInt(modalElement.getAttribute('data-countdown-seconds'));

    var state = {
      enabled: modalElement.getAttribute('data-enabled') === 'true',
      hasOffers: modalElement.getAttribute('data-has-offers') === 'true',
      pendingForm: null,
      pendingSubmitter: null,
      addInFlight: 0,
      isSubmitting: false,
      suppressDismissTracking: false,
      countdownTimer: null,
      countdownEndsAt: 0
    };

    function getCards() {
      return modalElement.querySelectorAll('[data-pre-checkout-upsell-card]');
    }

    function getSelectedOption(select) {
      if (!select || !select.options || !select.options.length) return null;
      var selectedIndex = select.selectedIndex >= 0 ? select.selectedIndex : 0;
      return select.options[selectedIndex] || null;
    }

    function isAvailable() {
      return !!(state.enabled && state.hasOffers && modalInstance);
    }

    function updateContinueButton() {
      if (!continueButton) return;
      var defaultLabel = continueButton.getAttribute('data-default-label') || 'Checkout';
      var shouldDisable = !state.pendingForm || state.addInFlight > 0 || state.isSubmitting;
      continueButton.disabled = shouldDisable;
      continueButton.setAttribute('aria-busy', state.isSubmitting ? 'true' : 'false');
      continueButton.textContent = state.isSubmitting ? 'Preparing...' : defaultLabel;
    }

    function updateCard(card) {
      if (!card) return;
      var select = card.querySelector('[data-pre-checkout-upsell-variant-select]');
      var selectedOption = getSelectedOption(select);
      var priceEl = card.querySelector('[data-pre-checkout-upsell-price]');
      var compareEl = card.querySelector('[data-pre-checkout-upsell-compare]');
      var addButton = card.querySelector('[data-pre-checkout-upsell-add]');

      var variantId = parsePositiveInt(selectedOption && selectedOption.value);
      var price = parsePositiveInt(selectedOption && selectedOption.getAttribute('data-price'));
      var compareAtPrice = parsePositiveInt(selectedOption && selectedOption.getAttribute('data-compare-at-price'));

      if (priceEl) {
        priceEl.textContent = formatThemeMoney(price);
      }

      if (compareEl) {
        compareEl.textContent = compareAtPrice > 0 ? formatThemeMoney(compareAtPrice) : '';
        compareEl.hidden = !(compareAtPrice > price);
      }

      if (!addButton) return;
      var defaultLabel = addButton.getAttribute('data-default-label') || 'Add to Bag';
      var isLoading = addButton.getAttribute('data-loading') === 'true';
      addButton.setAttribute('data-variant-id', variantId > 0 ? String(variantId) : '');
      addButton.disabled = state.isSubmitting || isLoading || !variantId;
      addButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (!isLoading) {
        addButton.textContent = defaultLabel;
      }
    }

    function updateAllCards() {
      getCards().forEach(function (card) {
        updateCard(card);
      });
      updateContinueButton();
    }

    function stopCountdown() {
      if (!state.countdownTimer) return;
      window.clearInterval(state.countdownTimer);
      state.countdownTimer = null;
    }

    function renderCountdown() {
      if (!timerElement || !countdownSeconds) return;
      var remaining = Math.max(0, Math.ceil((state.countdownEndsAt - Date.now()) / 1000));
      var minutes = Math.floor(remaining / 60);
      var seconds = remaining % 60;
      timerElement.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      if (remaining <= 0) {
        stopCountdown();
      }
    }

    function startCountdown() {
      if (!timerElement || !countdownSeconds) return;
      stopCountdown();
      state.countdownEndsAt = Date.now() + countdownSeconds * 1000;
      renderCountdown();
      state.countdownTimer = window.setInterval(renderCountdown, 1000);
    }

    function clearPendingCheckout() {
      state.pendingForm = null;
      state.pendingSubmitter = null;
      state.isSubmitting = false;
      state.suppressDismissTracking = false;
      updateAllCards();
    }

    getCards().forEach(function (card) {
      var select = card.querySelector('[data-pre-checkout-upsell-variant-select]');
      var addButton = card.querySelector('[data-pre-checkout-upsell-add]');

      if (select) {
        select.addEventListener('change', function () {
          updateCard(card);
        });
      }

      if (addButton) {
        addButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (state.isSubmitting) return;

          var selectedOption = getSelectedOption(select);
          var variantId = parsePositiveInt(selectedOption && selectedOption.value);
          if (!variantId) {
            updateCard(card);
            return;
          }

          var defaultLabel = addButton.getAttribute('data-default-label') || 'Add to Bag';
          addButton.setAttribute('data-loading', 'true');
          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
          addButton.textContent = 'Adding...';
          state.addInFlight += 1;
          updateContinueButton();

          addPreCheckoutUpsellToCart(variantId, 1)
            .then(function () {
              pushDataLayer('pre_checkout_upsell_add', {
                upsell_product_id: card.getAttribute('data-product-id') || '',
                upsell_product_title: card.getAttribute('data-product-title') || '',
                upsell_variant_id: variantId
              });
              showToast('Offer added to your bag.');
            })
            .catch(function () {
              /* addPreCheckoutUpsellToCart already handles user-facing error messaging */
            })
            .finally(function () {
              state.addInFlight = Math.max(0, state.addInFlight - 1);
              addButton.removeAttribute('data-loading');
              addButton.removeAttribute('aria-busy');
              addButton.textContent = defaultLabel;
              updateCard(card);
              updateContinueButton();
            });
        });
      }

      updateCard(card);
    });

    if (continueButton) {
      continueButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (!state.pendingForm || state.isSubmitting || state.addInFlight > 0) return;

        var form = state.pendingForm;
        var submitter = state.pendingSubmitter;

        state.isSubmitting = true;
        updateAllCards();
        pushDataLayer('pre_checkout_upsell_continue');

        Promise.resolve()
          .then(function () {
            return typeof beforeCheckoutSubmit === 'function' ? beforeCheckoutSubmit(form, submitter) : null;
          })
          .then(function () {
            state.suppressDismissTracking = true;
            if (modalInstance && typeof modalInstance.close === 'function') {
              modalInstance.close();
            }
            submitCartFormForCheckout(form, submitter);
          })
          .catch(function (error) {
            state.isSubmitting = false;
            state.suppressDismissTracking = false;
            updateAllCards();
            if (!error || error.silent !== true) {
              showToast('Unable to continue to checkout right now. Please try again.');
            }
          });
      });
    }

    document.addEventListener('modalClose.' + modalId, function () {
      stopCountdown();

      if (state.pendingForm && !state.isSubmitting && !state.suppressDismissTracking) {
        pushDataLayer('pre_checkout_upsell_dismiss');
      }

      clearPendingCheckout();
    });

    updateContinueButton();

    return {
      isAvailable: isAvailable,
      openForCheckout: function (form, submitter) {
        if (!isAvailable()) return;
        state.pendingForm = form;
        state.pendingSubmitter = submitter || null;
        state.isSubmitting = false;
        state.suppressDismissTracking = false;
        updateAllCards();
        startCountdown();
        pushDataLayer('pre_checkout_upsell_view');
        modalInstance.open();
      }
    };
  }

  function parseBogoEligibleHandles(raw) {
    return String(raw || '')
      .split(/[\n,]+/)
      .map(function (value) {
        return value.trim().toLowerCase();
      })
      .filter(function (value) {
        return value.length > 0;
      });
  }

  function parseBogoFreeHandleMap(raw) {
    var map = {};
    String(raw || '')
      .split(/[\n,]+/)
      .map(function (value) {
        return value.trim();
      })
      .filter(function (value) {
        return value.length > 0;
      })
      .forEach(function (entry) {
        var pair = entry.split(/\s*(?:=>|=|:)\s*/);
        if (pair.length < 2) return;
        var paidHandle = String(pair[0] || '').trim().toLowerCase();
        var freeHandle = String(pair[1] || '').trim().toLowerCase();
        if (!paidHandle || !freeHandle) return;
        map[paidHandle] = freeHandle;
      });
    return map;
  }

  function getBogoSettings() {
    var settings = window.theme && theme.settings ? theme.settings : {};
    var enabled = !!settings.tallOwlBogoEnabled;
    var freeHandleMap = parseBogoFreeHandleMap(settings.tallOwlBogoFreeHandleMap);
    var handles = parseBogoEligibleHandles(settings.tallOwlBogoEligibleHandles);
    var freeHandles = Object.keys(freeHandleMap)
      .map(function (paidHandle) {
        return normalizeText(freeHandleMap[paidHandle]);
      })
      .filter(function (handle) {
        return handle.length > 0;
      });

    freeHandles = Array.from(new Set(freeHandles));
    if (!handles.length) {
      handles = Object.keys(freeHandleMap);
    }

    return {
      enabled: enabled && (handles.length > 0 || freeHandles.length > 0),
      handles: handles,
      handleSet: new Set(handles),
      freeHandleMap: freeHandleMap,
      freeHandles: freeHandles,
      freeHandleSet: new Set(freeHandles)
    };
  }

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function dispatchBogoSyncState(syncing) {
    document.dispatchEvent(
      new CustomEvent('tall-owl:bogo-sync-state', {
        detail: {
          syncing: !!syncing
        }
      })
    );
  }

  function setCheckoutSyncLocked(locked) {
    var nextLocked = !!locked;
    if (checkoutSyncLocked === nextLocked) return;
    checkoutSyncLocked = nextLocked;

    document.documentElement.classList.toggle('tall-owl-bogo-syncing', nextLocked);

    document
      .querySelectorAll(
        '.cart__checkout, .additional-checkout-buttons, .tall-owl-manual-wallet, [data-tall-owl-bogo-quick-buy], [data-pre-checkout-upsell-continue], [data-pre-checkout-upsell-add]'
      )
      .forEach(function (el) {
        if (nextLocked) {
          el.setAttribute('data-tall-owl-checkout-locked', 'true');
        } else {
          el.removeAttribute('data-tall-owl-checkout-locked');
        }
      });
  }

  function getHandleFromPath(pathValue) {
    var path = String(pathValue || '');
    var match = path.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? normalizeText(decodeURIComponent(match[1])) : '';
  }

  function getQuickBuyButtonProductHandle(button) {
    if (!button) return '';

    var explicit = normalizeText(button.getAttribute('data-product-handle'));
    if (explicit) return explicit;

    var hotReload = button.closest('product-hot-reload');
    if (hotReload) {
      var hotReloadHandle = getHandleFromPath(hotReload.getAttribute('data-product-url'));
      if (hotReloadHandle) return hotReloadHandle;
    }

    return getHandleFromPath(window.location.pathname);
  }

  function getQuickBuyButtonVariantId(button) {
    var form = button && button.closest ? button.closest('form') : null;
    if (!form) return 0;
    var variantField = form.querySelector('input[name="id"], select[name="id"], select[data-product-select]');
    if (!variantField) return 0;

    var variantValue = variantField.value;
    if (!variantValue && variantField.tagName === 'SELECT') {
      var selectedOption = variantField.options && variantField.selectedIndex >= 0 ? variantField.options[variantField.selectedIndex] : null;
      variantValue = selectedOption && selectedOption.value ? selectedOption.value : '';
    }

    return parsePositiveInt(variantValue);
  }

  function getQuickBuyButtonQuantity(button) {
    var form = button && button.closest ? button.closest('form') : null;
    if (!form) return 1;
    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = parsePositiveInt(quantityInput && quantityInput.value);
    return quantity > 0 ? quantity : 1;
  }

  function syncBogoQuickBuyButtons() {
    var config = getBogoSettings();
    var buttons = document.querySelectorAll('[data-tall-owl-bogo-quick-buy]');
    var disableQuickBuyOnProductPages = document.body && document.body.classList.contains('template-product');
    if (buttons.length) {
      buttons.forEach(function (button) {
        var handle = getQuickBuyButtonProductHandle(button);
        var shouldShow = !!(!disableQuickBuyOnProductPages && config.enabled && handle && config.handleSet.has(handle));
        button.hidden = !shouldShow;
      });
    }

    syncBogoProductDynamicCheckoutVisibility();
  }

  function syncBogoProductDynamicCheckoutVisibility() {
    var config = getBogoSettings();
    var wrappers = document.querySelectorAll('.element-button--shopify-payment-wrapper, .payment-buttons .shopify-payment-button');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var form = wrapper.closest('form');
      var quickBuyButton = form ? form.querySelector('[data-tall-owl-bogo-quick-buy]') : null;
      var handle = quickBuyButton ? getQuickBuyButtonProductHandle(quickBuyButton) : getHandleFromPath(window.location.pathname);
      var shouldHide = !!(
        config.enabled &&
        handle &&
        (config.handleSet.has(handle) || (config.freeHandleSet && config.freeHandleSet.has(handle)))
      );

      wrapper.hidden = shouldHide;
      if (shouldHide) {
        wrapper.setAttribute('aria-hidden', 'true');
      } else {
        wrapper.removeAttribute('aria-hidden');
      }
    });
  }

  function initBogoQuickBuyButtons() {
    syncBogoQuickBuyButtons();

    if (!window.MutationObserver) return;
    var root = document.getElementById('MainContent');
    if (!root) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('[data-tall-owl-bogo-quick-buy]')) return true;
          return !!(node.querySelector && node.querySelector('[data-tall-owl-bogo-quick-buy]'));
        });
      });

      if (shouldSync) {
        syncBogoQuickBuyButtons();
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function isCartCheckoutForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (form.id === 'CartDrawerForm') return true;
    if (form.getAttribute('data-location') === 'cart-drawer') return true;

    var action = String(form.getAttribute('action') || '').split('?')[0];
    if (!action || action.indexOf('/cart') === -1) return false;

    return !!form.querySelector('button[name="checkout"], .cart__checkout, .additional-checkout-buttons');
  }

  function submitCartFormForCheckout(form, submitter) {
    if (!form) return;
    form.setAttribute('data-tall-owl-bogo-submit-bypass', 'true');

    if (typeof form.requestSubmit === 'function') {
      if (submitter && submitter.form === form) {
        form.requestSubmit(submitter);
        return;
      }

      var checkoutButton = form.querySelector('button[name="checkout"], .cart__checkout');
      if (checkoutButton) {
        form.requestSubmit(checkoutButton);
      } else {
        form.requestSubmit();
      }
      return;
    }

    var hiddenCheckoutInput = document.createElement('input');
    hiddenCheckoutInput.type = 'hidden';
    hiddenCheckoutInput.name = 'checkout';
    hiddenCheckoutInput.value = 'Checkout';
    form.appendChild(hiddenCheckoutInput);
    form.submit();
    if (hiddenCheckoutInput.parentNode) {
      hiddenCheckoutInput.parentNode.removeChild(hiddenCheckoutInput);
    }
  }

  function initBogoCheckoutGuards(controller) {
    var hasBogoController = !!(controller && typeof controller.flushSync === 'function');
    var preCheckoutController = createPreCheckoutUpsellController(function () {
      if (!hasBogoController) {
        return Promise.resolve();
      }

      setCheckoutSyncLocked(true);
      return controller.flushSync('checkout-submit').catch(function (error) {
        setCheckoutSyncLocked(false);
        showToast('Unable to sync free item before checkout. Please try again.');

        if (error && typeof error === 'object') {
          error.silent = true;
          throw error;
        }

        throw { silent: true };
      });
    });

    document.addEventListener('tall-owl:bogo-sync-state', function (event) {
      var syncing = !!(event.detail && event.detail.syncing);
      setCheckoutSyncLocked(syncing);
    });

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!isCartCheckoutForm(form)) return;
        var hasUpsellController = !!(preCheckoutController && preCheckoutController.isAvailable && preCheckoutController.isAvailable());
        if (!hasUpsellController && !hasBogoController) return;
        var submitter = event.submitter || null;

        if (form.getAttribute('data-tall-owl-bogo-submit-bypass') === 'true') {
          form.removeAttribute('data-tall-owl-bogo-submit-bypass');
          return;
        }

        var termsCheckbox = form.querySelector('.cart__terms-checkbox');
        if (termsCheckbox && !termsCheckbox.checked) return;

        if (hasUpsellController) {
          event.preventDefault();
          preCheckoutController.openForCheckout(form, submitter);
          return;
        }

        if (!hasBogoController) return;

        event.preventDefault();
        setCheckoutSyncLocked(true);

        controller
          .flushSync('checkout-submit')
          .then(function () {
            submitCartFormForCheckout(form, submitter);
          })
          .catch(function () {
            setCheckoutSyncLocked(false);
            showToast('Unable to sync free item before checkout. Please try again.');
          });
      },
      true
    );
  }

  function initCartDrawerScrollReset() {
    document.addEventListener('drawerOpen.CartDrawer', function () {
      var resetScroll = function () {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer) return;

        var inner = drawer.querySelector('.drawer__inner');
        if (inner) {
          inner.scrollTop = 0;
        }

        var scrollable = drawer.querySelector('.drawer__inner > .drawer__scrollable');
        if (scrollable) {
          scrollable.scrollTop = 0;
        }
      };

      window.requestAnimationFrame(resetScroll);
      window.setTimeout(resetScroll, 120);
      window.setTimeout(resetScroll, 360);
    });
  }

  function getWalletSignals(element) {
    if (!element) return '';

    var parts = [];
    var seen = {};

    function push(value) {
      var token = normalizeText(value);
      if (!token || seen[token]) return;
      seen[token] = true;
      parts.push(token);
    }

    function collectFromNode(node) {
      if (!node || node.nodeType !== 1 || !node.getAttribute) return;
      ['aria-label', 'title', 'name', 'data-testid', 'data-provider', 'data-payment-method', 'alt', 'id', 'class'].forEach(
        function (attr) {
          push(node.getAttribute(attr));
        }
      );
      if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
        push(node.getAttribute('src'));
      }
    }

    collectFromNode(element);

    var descendants = element.querySelectorAll
      ? element.querySelectorAll('[aria-label],[title],[name],[data-testid],[data-provider],[data-payment-method],[alt],[id],[class],iframe')
      : [];
    var maxDescendants = Math.min(descendants.length, 120);
    for (var i = 0; i < maxDescendants; i += 1) {
      collectFromNode(descendants[i]);
    }

    push(element.textContent || '');
    push(element.innerHTML || '');

    return parts.join(' ');
  }

  function detectWalletProvider(element) {
    var haystack = getWalletSignals(element);
    if (!haystack) return 'unknown';

    if (
      haystack.indexOf('shop pay') !== -1 ||
      haystack.indexOf('shop-pay') !== -1 ||
      haystack.indexOf('shop_pay') !== -1 ||
      haystack.indexOf('shoppay') !== -1 ||
      haystack.indexOf('shopify pay') !== -1
    ) {
      return 'shop';
    }

    if (
      haystack.indexOf('paypal') !== -1 ||
      haystack.indexOf('pay pal') !== -1 ||
      haystack.indexOf('paypal.com') !== -1 ||
      haystack.indexOf('paypalobjects') !== -1
    ) {
      return 'paypal';
    }

    if (
      haystack.indexOf('amazon') !== -1 ||
      haystack.indexOf('amzn') !== -1 ||
      haystack.indexOf('amazon pay') !== -1
    ) {
      return 'amazon';
    }

    if (
      haystack.indexOf('google pay') !== -1 ||
      haystack.indexOf('googlepay') !== -1 ||
      haystack.indexOf('gpay') !== -1 ||
      haystack.indexOf('pay.google') !== -1
    ) {
      return 'google';
    }

    if (haystack.indexOf('apple pay') !== -1 || haystack.indexOf('applepay') !== -1) {
      return 'apple';
    }

    return 'other';
  }

  function getCartDrawerWalletContainers(drawer) {
    if (!drawer) return [];

    var nested = Array.prototype.slice.call(
      drawer.querySelectorAll('.additional-checkout-buttons [data-shopify-buttoncontainer]')
    );
    if (nested.length) {
      return nested;
    }

    return Array.prototype.slice
      .call(drawer.querySelectorAll('.additional-checkout-buttons'))
      .filter(function (container) {
        return !!container;
      });
  }

  function getWalletCandidates(container) {
    if (!container || !container.children) return [];
    return Array.prototype.filter.call(container.children, function (child) {
      if (!child || child.nodeType !== 1) return false;
      var tag = (child.tagName || '').toLowerCase();
      return tag !== 'script' && tag !== 'style' && tag !== 'template';
    });
  }

  function setWalletVisible(node, visible) {
    if (!node) return;
    node.classList.toggle('tall-owl-wallet-hidden', !visible);
    if (visible) {
      node.removeAttribute('aria-hidden');
      node.style.removeProperty('display');
      return;
    }
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
  }

  function filterCartDrawerWalletButtons() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var containers = getCartDrawerWalletContainers(drawer);
    if (!containers.length) return;

    containers.forEach(function (container) {
      container.classList.add('tall-owl-wallet-container');

      var candidates = getWalletCandidates(container);
      if (!candidates.length) return;

      var shopNode = null;
      var paypalNode = null;
      var allowedFallback = [];

      candidates.forEach(function (candidate) {
        var provider = detectWalletProvider(candidate);
        candidate.setAttribute('data-tall-owl-wallet-provider', provider);

        if (provider === 'shop' && !shopNode) {
          shopNode = candidate;
        } else if (provider === 'paypal' && !paypalNode) {
          paypalNode = candidate;
        } else if (provider !== 'amazon' && provider !== 'google' && provider !== 'apple') {
          allowedFallback.push(candidate);
        }
      });

      var keep = [];
      if (shopNode) keep.push(shopNode);
      if (paypalNode && keep.indexOf(paypalNode) === -1) keep.push(paypalNode);

      if (keep.length < 2) {
        allowedFallback.forEach(function (candidate) {
          if (keep.length >= 2) return;
          if (keep.indexOf(candidate) !== -1) return;
          keep.push(candidate);
        });
      }

      if (keep.length < 2) {
        candidates.forEach(function (candidate) {
          if (keep.length >= 2) return;
          if (keep.indexOf(candidate) !== -1) return;
          keep.push(candidate);
        });
      }

      keep = keep.slice(0, 2);

      candidates.forEach(function (candidate) {
        var visible = keep.indexOf(candidate) !== -1;
        setWalletVisible(candidate, visible);
        candidate.style.order = visible ? String(keep.indexOf(candidate) + 1) : '';
      });
    });
  }

  function scheduleCartDrawerWalletFilter() {
    [0, 120, 360, 900].forEach(function (delay) {
      window.setTimeout(filterCartDrawerWalletButtons, delay);
    });
  }

  function initCartDrawerWalletButtons() {
    scheduleCartDrawerWalletFilter();

    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      scheduleCartDrawerWalletFilter();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });

    document.addEventListener('cart:updated', function () {
      scheduleCartDrawerWalletFilter();
    });

    document.addEventListener('drawerOpen.CartDrawer', function () {
      scheduleCartDrawerWalletFilter();
    });

    window.addEventListener('load', function () {
      scheduleCartDrawerWalletFilter();
    });
  }

  function slugifyHandle(value) {
    return normalizeText(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

  function fetchCartJson() {
    var cartUrl = window.theme && theme.routes && theme.routes.cart ? theme.routes.cart : '/cart.js';
    var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(cartUrl + separator + 't=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart JSON');
      return response.json();
    });
  }

  function postCartJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function fetchProductByHandle(handle) {
    var normalizedHandle = normalizeText(handle);
    if (!normalizedHandle) return Promise.reject(new Error('Missing product handle'));
    if (tallOwlBogoProductCache[normalizedHandle]) return tallOwlBogoProductCache[normalizedHandle];

    tallOwlBogoProductCache[normalizedHandle] = fetch('/products/' + encodeURIComponent(normalizedHandle) + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product for handle: ' + normalizedHandle);
        return response.json();
      })
      .catch(function (error) {
        delete tallOwlBogoProductCache[normalizedHandle];
        throw error;
      });

    return tallOwlBogoProductCache[normalizedHandle];
  }

  function resolveFreeHandleForPaidHandle(paidHandle, lineItem, bogoConfig) {
    var normalizedPaidHandle = normalizeText(paidHandle);
    if (!normalizedPaidHandle) return Promise.resolve('');

    if (Object.prototype.hasOwnProperty.call(bogoConfig.freeHandleMap, normalizedPaidHandle)) {
      return Promise.resolve(normalizeText(bogoConfig.freeHandleMap[normalizedPaidHandle]));
    }

    if (Object.prototype.hasOwnProperty.call(tallOwlBogoResolvedFreeHandleCache, normalizedPaidHandle)) {
      return tallOwlBogoResolvedFreeHandleCache[normalizedPaidHandle];
    }

    var titleSlug = slugifyHandle((lineItem && lineItem.product_title) || (lineItem && lineItem.title) || '');
    var baseHandles = Array.from(
      new Set(
        [normalizedPaidHandle, titleSlug].filter(function (value) {
          return value.length > 0;
        })
      )
    );

    var suffixes = ['-100-off', '-100-percent-off', '-free', '-gift'];
    var candidates = [];
    baseHandles.forEach(function (baseHandle) {
      candidates.push(baseHandle);
      suffixes.forEach(function (suffix) {
        candidates.push(baseHandle + suffix);
      });
    });
    candidates = Array.from(new Set(candidates));

    var lookup = Promise.resolve('');
    candidates.forEach(function (candidateHandle) {
      lookup = lookup.then(function (resolvedHandle) {
        if (resolvedHandle) return resolvedHandle;
        return fetchProductByHandle(candidateHandle)
          .then(function (product) {
            var title = normalizeText(product && product.title);
            if (title.indexOf('100% off') !== -1 || title.indexOf('100 off') !== -1) {
              return candidateHandle;
            }
            return '';
          })
          .catch(function () {
            return '';
          });
      });
    });

    tallOwlBogoResolvedFreeHandleCache[normalizedPaidHandle] = lookup;
    return lookup;
  }

  function addBogoGiftLine(variantId, quantity) {
    var cartAddUrl = window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add.js';
    return postCartJson(cartAddUrl, {
      id: Number(variantId),
      quantity: quantity,
      properties: {
        _tall_owl_bogo_role: 'gift',
        _tall_owl_bogo_source: 'theme-auto'
      }
    });
  }

  function changeCartLineQuantity(key, quantity) {
    var cartChangeUrl = window.theme && theme.routes && theme.routes.cartChange ? theme.routes.cartChange : '/cart/change.js';
    return postCartJson(cartChangeUrl, {
      id: key,
      quantity: quantity
    });
  }

  function parsePositiveInt(value) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed)) return 0;
    return Math.max(0, Math.round(parsed));
  }

  function getLineItemProperty(item, key) {
    if (!item || !item.properties || typeof item.properties !== 'object') return '';
    var value = item.properties[key];
    return value == null ? '' : String(value).trim();
  }

  function getLineItemHandle(item) {
    if (!item) return '';
    var directHandle = String(item.handle || '').trim().toLowerCase();
    if (directHandle) return directHandle;

    var url = String(item.url || '');
    var match = url.match(/\/products\/([^/?]+)/);
    return match && match[1] ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function formatLineItemVariantLabel(item) {
    if (!item) return '';

    var parts = [];
    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (option) {
        var name = String((option && option.name) || '').trim();
        var value = String((option && option.value) || '').trim();
        if (!value || normalizeText(value) === 'default title') return;
        parts.push(name ? name + ': ' + value : value);
      });
    }

    if (!parts.length && Array.isArray(item.variant_options)) {
      item.variant_options.forEach(function (value) {
        var clean = String(value || '').trim();
        if (!clean || normalizeText(clean) === 'default title') return;
        parts.push(clean);
      });
    }

    if (!parts.length) {
      var variantTitle = String(item.variant_title || '').trim();
      if (variantTitle && normalizeText(variantTitle) !== 'default title') {
        parts = variantTitle
          .split(' / ')
          .map(function (part) {
            return String(part || '').trim();
          })
          .filter(function (part) {
            return part.length > 0;
          });
      }
    }

    return parts.join(' • ');
  }

  function getLineItemOptionsByName(item) {
    var optionsByName = {};
    if (!item || !Array.isArray(item.options_with_values)) return optionsByName;

    item.options_with_values.forEach(function (option) {
      var name = normalizeText(option && option.name);
      var value = normalizeText(option && option.value);
      if (!name || !value || value === 'default title') return;
      optionsByName[name] = value;
    });

    return optionsByName;
  }

  function getVariantOptionsByName(product, variant) {
    var optionsByName = {};
    var optionNames = product && Array.isArray(product.options) ? product.options : [];
    var optionValues = [variant && variant.option1, variant && variant.option2, variant && variant.option3];

    optionValues.forEach(function (rawValue, index) {
      var value = normalizeText(rawValue);
      if (!value || value === 'default title') return;
      var name = normalizeText(optionNames[index] || '');
      if (!name) return;
      optionsByName[name] = value;
    });

    return optionsByName;
  }

  function optionMapsExactlyMatch(source, target) {
    var sourceKeys = Object.keys(source || {});
    var targetKeys = Object.keys(target || {});
    if (sourceKeys.length !== targetKeys.length) return false;

    return sourceKeys.every(function (key) {
      return target[key] === source[key];
    });
  }

  function findMatchingGiftVariantId(freeProduct, lineItem) {
    var variants = freeProduct && Array.isArray(freeProduct.variants) ? freeProduct.variants : [];
    if (!variants.length) return 0;

    var lineOptionsByName = getLineItemOptionsByName(lineItem);
    var hasLineOptions = Object.keys(lineOptionsByName).length > 0;
    if (hasLineOptions) {
      for (var i = 0; i < variants.length; i += 1) {
        var variantOptionsByName = getVariantOptionsByName(freeProduct, variants[i]);
        if (!optionMapsExactlyMatch(lineOptionsByName, variantOptionsByName)) continue;
        return parsePositiveInt(variants[i].id);
      }
    }

    var normalizedVariantTitle = normalizeText(lineItem && lineItem.variant_title);
    if (normalizedVariantTitle && normalizedVariantTitle !== 'default title') {
      for (var j = 0; j < variants.length; j += 1) {
        if (normalizeText(variants[j].title) === normalizedVariantTitle) {
          return parsePositiveInt(variants[j].id);
        }
      }
    }

    if (!hasLineOptions && (!normalizedVariantTitle || normalizedVariantTitle === 'default title') && variants.length === 1) {
      return parsePositiveInt(variants[0].id);
    }

    return 0;
  }

  function resolveGiftVariantIdForLineItem(lineItem, paidHandle, bogoConfig) {
    var normalizedPaidHandle = normalizeText(paidHandle);
    var paidVariantId = parsePositiveInt(lineItem && lineItem.variant_id);
    var variantCacheKey = paidVariantId && normalizedPaidHandle ? String(paidVariantId) + '::' + normalizedPaidHandle : '';

    if (variantCacheKey && Object.prototype.hasOwnProperty.call(tallOwlBogoResolvedGiftVariantCache, variantCacheKey)) {
      return Promise.resolve(parsePositiveInt(tallOwlBogoResolvedGiftVariantCache[variantCacheKey]));
    }

    return resolveFreeHandleForPaidHandle(paidHandle, lineItem, bogoConfig)
      .then(function (freeHandle) {
        if (!freeHandle) return 0;
        return fetchProductByHandle(freeHandle)
          .then(function (freeProduct) {
            var resolvedGiftVariantId = findMatchingGiftVariantId(freeProduct, lineItem);
            if (variantCacheKey && resolvedGiftVariantId > 0) {
              tallOwlBogoResolvedGiftVariantCache[variantCacheKey] = resolvedGiftVariantId;
              persistBogoGiftVariantCache();
            }
            return resolvedGiftVariantId;
          })
          .catch(function () {
            return 0;
          });
      })
      .catch(function () {
        return 0;
      });
  }

  function isBogoGiftLine(item, bogoConfig) {
    var role = getLineItemProperty(item, '_tall_owl_bogo_role').toLowerCase();
    if (role === 'gift') return true;

    var boolFlag = getLineItemProperty(item, '_tall_owl_bogo_gift').toLowerCase();
    if (boolFlag === 'true' || boolFlag === '1' || boolFlag === 'yes') return true;

    var config = bogoConfig || getBogoSettings();
    if (config && config.freeHandleSet && config.freeHandleSet.size) {
      var handle = getLineItemHandle(item);
      if (handle && config.freeHandleSet.has(handle)) return true;
    }

    var title = normalizeText((item && item.product_title) || (item && item.title));
    if (title.indexOf('100% off') !== -1 || title.indexOf('100 off') !== -1) return true;

    var finalPrice = parsePositiveInt(item && item.final_price);
    var originalPrice = parsePositiveInt(item && item.original_price);
    if (finalPrice !== 0) return false;

    if (originalPrice === 0) return true;
    return originalPrice > 0;
  }

  function createBogoSyncPlan(cart, bogoConfig) {
    var giftLinesByVariant = {};
    var paidLines = [];

    if (!cart || !Array.isArray(cart.items)) {
      return Promise.resolve({ addActions: [], changeActions: [], unresolvedPaidCount: 0 });
    }

    cart.items.forEach(function (item) {
      var variantId = parsePositiveInt(item && item.variant_id);
      var quantity = parsePositiveInt(item && item.quantity);
      if (!variantId || !quantity) return;
      var handle = getLineItemHandle(item);

      var legacyFreeLine = parsePositiveInt(item && item.final_price) === 0;
      if (isBogoGiftLine(item, bogoConfig) || legacyFreeLine) {
        if (!giftLinesByVariant[variantId]) giftLinesByVariant[variantId] = [];
        giftLinesByVariant[variantId].push({
          key: item.key,
          quantity: quantity
        });
        return;
      }

      if (item && item.selling_plan_allocation) return;
      if (item && item.gift_card) return;

      if (!bogoConfig.handleSet.has(handle)) return;

      paidLines.push({
        item: item,
        handle: handle,
        quantity: quantity
      });
    });

    var resolverCache = {};
    var resolutionTasks = paidLines.map(function (line) {
      var cacheKey = String(line.item && line.item.variant_id) + '::' + line.handle;
      if (!resolverCache[cacheKey]) {
        resolverCache[cacheKey] = resolveGiftVariantIdForLineItem(line.item, line.handle, bogoConfig);
      }
      return resolverCache[cacheKey].then(function (giftVariantId) {
        return {
          giftVariantId: parsePositiveInt(giftVariantId),
          quantity: line.quantity,
          sourceTitle: String((line.item && (line.item.product_title || line.item.title)) || '').trim(),
          sourceVariantLabel: formatLineItemVariantLabel(line.item)
        };
      });
    });

    return Promise.all(resolutionTasks).then(function (resolvedPaidLines) {
      var desiredGiftQtyByVariant = {};
      var sourceByGiftVariant = {};
      var unresolvedPaidCount = 0;
      resolvedPaidLines.forEach(function (line) {
        if (!line.giftVariantId) {
          unresolvedPaidCount += line.quantity;
          return;
        }
        if (!sourceByGiftVariant[line.giftVariantId]) {
          sourceByGiftVariant[line.giftVariantId] = {
            sourceTitle: line.sourceTitle,
            sourceVariantLabel: line.sourceVariantLabel
          };
        }
        desiredGiftQtyByVariant[line.giftVariantId] = (desiredGiftQtyByVariant[line.giftVariantId] || 0) + line.quantity;
      });

      var variantIds = {};
      Object.keys(desiredGiftQtyByVariant).forEach(function (variantId) {
        variantIds[variantId] = true;
      });
      Object.keys(giftLinesByVariant).forEach(function (variantId) {
        variantIds[variantId] = true;
      });

      var addActions = [];
      var changeActions = [];

      Object.keys(variantIds).forEach(function (variantKey) {
        var variantId = parsePositiveInt(variantKey);
        if (!variantId) return;

        var desiredGiftQty = desiredGiftQtyByVariant[variantId] || 0;
        var giftLines = giftLinesByVariant[variantId] || [];
        var currentGiftQty = giftLines.reduce(function (total, line) {
          return total + parsePositiveInt(line.quantity);
        }, 0);

        if (currentGiftQty < desiredGiftQty) {
          var source = sourceByGiftVariant[variantId] || {};
          addActions.push({
            variantId: variantId,
            quantity: desiredGiftQty - currentGiftQty,
            sourceTitle: source.sourceTitle || '',
            sourceVariantLabel: source.sourceVariantLabel || ''
          });
          return;
        }

        if (currentGiftQty > desiredGiftQty) {
          var remainingQty = desiredGiftQty;
          giftLines.forEach(function (line) {
            var lineQty = parsePositiveInt(line.quantity);
            var nextQty = remainingQty > 0 ? Math.min(remainingQty, lineQty) : 0;
            remainingQty = Math.max(remainingQty - nextQty, 0);

            if (nextQty !== lineQty) {
              changeActions.push({
                key: line.key,
                quantity: nextQty
              });
            }
          });
        }
      });

      return {
        addActions: addActions,
        changeActions: changeActions,
        unresolvedPaidCount: unresolvedPaidCount
      };
    });
  }

  function applyBogoSyncPlan(plan) {
    var base = Promise.resolve();

    plan.changeActions.forEach(function (action) {
      base = base.then(function () {
        return changeCartLineQuantity(action.key, action.quantity);
      });
    });

    plan.addActions.forEach(function (action) {
      base = base.then(function () {
        return addBogoGiftLine(action.variantId, action.quantity);
      });
    });

    return base;
  }

  function findGiftLineByVariantId(cart, variantId) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return null;
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (parsePositiveInt(item && item.variant_id) !== parsePositiveInt(variantId)) continue;
      if (!isBogoGiftLine(item)) continue;
      return item;
    }
    return null;
  }

  function buildBogoPopupPayload(plan, cart) {
    if (!plan || !Array.isArray(plan.addActions) || !plan.addActions.length) return null;

    var primary = plan.addActions[0];
    var totalAdded = plan.addActions.reduce(function (total, action) {
      return total + parsePositiveInt(action.quantity);
    }, 0);
    var giftLine = findGiftLineByVariantId(cart, primary.variantId);
    var freeTitle = giftLine ? String(giftLine.product_title || giftLine.title || '').trim() : '';
    var freeVariantLabel = giftLine ? formatLineItemVariantLabel(giftLine) : '';

    return {
      sourceTitle: String(primary.sourceTitle || '').trim(),
      freeTitle: freeTitle,
      variantLabel: String(primary.sourceVariantLabel || freeVariantLabel || '').trim(),
      totalAdded: totalAdded,
      extraLineCount: Math.max(plan.addActions.length - 1, 0)
    };
  }

  function createBogoCartSyncController() {
    var config = getBogoSettings();
    if (!config.enabled) return null;

    var state = {
      isSyncing: false,
      queued: false,
      queuedCart: null,
      timer: null,
      suppressNextCartUpdated: false,
      unresolvedWarningShown: false,
      flushResolvers: [],
      lastSyncingState: false
    };

    function hasPendingSync() {
      return state.isSyncing || state.queued || !!state.timer;
    }

    function notifySyncState() {
      var syncing = hasPendingSync();
      if (syncing === state.lastSyncingState) return;
      state.lastSyncingState = syncing;
      dispatchBogoSyncState(syncing);
    }

    function resolveFlushesWhenIdle() {
      if (hasPendingSync()) return;
      if (!state.flushResolvers.length) return;
      var resolvers = state.flushResolvers.slice();
      state.flushResolvers = [];
      resolvers.forEach(function (resolve) {
        resolve();
      });
    }

    function requestSync(reason, immediate, cartSnapshot) {
      var queuedCartSnapshot = cartSnapshot && Array.isArray(cartSnapshot.items) ? cartSnapshot : null;
      if (queuedCartSnapshot) {
        state.queuedCart = queuedCartSnapshot;
      }

      if (state.isSyncing) {
        state.queued = true;
        notifySyncState();
        return;
      }

      if (state.timer) {
        window.clearTimeout(state.timer);
      }

      var delay = immediate ? 0 : reason === 'init' ? 160 : 80;
      state.timer = window.setTimeout(function () {
        state.timer = null;
        notifySyncState();
        var nextCartSnapshot = state.queuedCart;
        state.queuedCart = null;
        runSync(reason, nextCartSnapshot);
      }, delay);
      notifySyncState();
    }

    function runSync(reason, cartSnapshot) {
      if (state.isSyncing) {
        state.queued = true;
        var queuedCartSnapshot = cartSnapshot && Array.isArray(cartSnapshot.items) ? cartSnapshot : null;
        if (queuedCartSnapshot) {
          state.queuedCart = queuedCartSnapshot;
        }
        notifySyncState();
        return;
      }

      state.isSyncing = true;
      notifySyncState();

      var activeCartSnapshot = cartSnapshot && Array.isArray(cartSnapshot.items) ? cartSnapshot : null;
      (activeCartSnapshot ? Promise.resolve(activeCartSnapshot) : fetchCartJson())
        .then(function (cart) {
          return createBogoSyncPlan(cart, config);
        })
        .then(function (plan) {
          if (plan.unresolvedPaidCount > 0 && !state.unresolvedWarningShown && reason !== 'init') {
            state.unresolvedWarningShown = true;
            showToast('Free 100% OFF match not found for one item.');
          }

          if (!plan.addActions.length && !plan.changeActions.length) return null;
          return applyBogoSyncPlan(plan).then(function () {
            return fetchCartJson().then(function (updatedCart) {
              if (plan.addActions.length && reason !== 'init') {
                showToast('BOGO active: matching free item added to cart.');
              }

              state.suppressNextCartUpdated = true;
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: {
                    cart: updatedCart
                  }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:build'));
            });
          });
        })
        .catch(function (error) {
          if (reason !== 'init') {
            showToast('Unable to sync your free 100% OFF item right now.');
          }
          console.warn('[Tall Owl BOGO] sync failed', error);
        })
        .finally(function () {
          state.isSyncing = false;
          if (state.queued) {
            state.queued = false;
            var nextCartSnapshot = state.queuedCart;
            state.queuedCart = null;
            requestSync('queued', true, nextCartSnapshot);
            return;
          }
          notifySyncState();
          resolveFlushesWhenIdle();
        });
    }

    return {
      requestSync: requestSync,
      flushSync: function (reason) {
        return new Promise(function (resolve) {
          state.flushResolvers.push(resolve);
          requestSync(reason || 'flush', true);
          notifySyncState();
          resolveFlushesWhenIdle();
        });
      },
      shouldSkipCartUpdated: function () {
        if (!state.suppressNextCartUpdated) return false;
        state.suppressNextCartUpdated = false;
        return true;
      }
    };
  }

  function initBogoAutoAdd() {
    var controller = createBogoCartSyncController();
    tallOwlBogoController = controller;

    initBogoCheckoutGuards(controller);

    if (!controller) return;

    document.addEventListener('cart:open', function () {
      closeBogoAddedPopup();
      controller.requestSync('cart:open', true);
    });

    document.addEventListener('ajaxProduct:added', function (event) {
      var cartFromEvent = event && event.detail ? event.detail.cart : null;
      controller.requestSync('ajaxProduct:added', false, cartFromEvent);
    });

    document.addEventListener('cart:updated', function (event) {
      if (controller.shouldSkipCartUpdated()) return;
      var cartFromEvent = event && event.detail ? event.detail.cart : null;
      controller.requestSync('cart:updated', false, cartFromEvent);
    });

    controller.requestSync('init');
  }

  function submitKlaviyoJsonp(listId, email, source, onSuccess, onError) {
    var callbackName = 'tallOwlKlaviyo_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    var script = document.createElement('script');
    var cleaned = false;

    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      if (script.parentNode) script.parentNode.removeChild(script);
      try {
        delete window[callbackName];
      } catch (error) {
        window[callbackName] = undefined;
      }
    }

    window[callbackName] = function (response) {
      cleanup();
      if (response && (response.success || response.data)) {
        onSuccess();
      } else {
        onError();
      }
    };

    script.async = true;
    script.src =
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe?callback=' +
      encodeURIComponent(callbackName) +
      '&g=' +
      encodeURIComponent(listId) +
      '&email=' +
      encodeURIComponent(email) +
      '&$fields=' +
      encodeURIComponent('$source') +
      '&$source=' +
      encodeURIComponent(source || 'homepage-newsletter');

    script.onerror = function () {
      cleanup();
      onError();
    };

    window.setTimeout(function () {
      if (!cleaned) {
        cleanup();
        onError();
      }
    }, 10000);

    document.head.appendChild(script);
  }

  function initKlaviyoNewsletterForms() {
    var forms = document.querySelectorAll('form[data-klaviyo-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var listId = form.getAttribute('data-klaviyo-list-id') || '';
        var source = form.getAttribute('data-newsletter-source') || 'homepage-newsletter';
        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button[type="submit"]');
        var status = form.querySelector('[data-newsletter-status]');
        var email = emailInput ? emailInput.value.trim() : '';
        var emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!emailIsValid || !listId) {
          if (status) {
            status.textContent = 'Please enter a valid email address and try again.';
            status.classList.remove('tall-owl-newsletter__status--success');
            status.classList.add('tall-owl-newsletter__status--error');
          }
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }
        if (status) {
          status.textContent = 'Submitting...';
          status.classList.remove('tall-owl-newsletter__status--success', 'tall-owl-newsletter__status--error');
        }

        submitKlaviyoJsonp(
          listId,
          email,
          source,
          function () {
            if (status) {
              status.textContent = 'Success. Check your inbox for your welcome email.';
              status.classList.remove('tall-owl-newsletter__status--error');
              status.classList.add('tall-owl-newsletter__status--success');
            }
            form.reset();
            pushDataLayer('newsletter_signup');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          },
          function () {
            if (status) {
              status.textContent = 'Unable to subscribe right now. Please try again.';
              status.classList.remove('tall-owl-newsletter__status--success');
              status.classList.add('tall-owl-newsletter__status--error');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          }
        );
      });
    });
  }

  function normalizeInputModes() {
    document.querySelectorAll('input[type="email"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'email');
    });
    document.querySelectorAll('input[type="tel"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'tel');
    });
    document.querySelectorAll('input[type="search"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'search');
    });
    document.querySelectorAll('input[type="url"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'url');
    });
  }

  function buildContactCreationDate(now) {
    try {
      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      }).format(now);
    } catch (error) {
      return now.toISOString();
    }
  }

  function applyContactCreationDateFields(form) {
    if (!form || !form.querySelectorAll) return;
    var now = new Date();
    var formatted = buildContactCreationDate(now);
    var iso = now.toISOString();

    Array.prototype.forEach.call(form.querySelectorAll('[data-contact-creation-date]'), function (input) {
      input.value = formatted;
    });

    Array.prototype.forEach.call(form.querySelectorAll('[data-contact-creation-date-iso]'), function (input) {
      input.value = iso;
    });
  }

  function initContactCreationDateFields() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
      if (!form.querySelector('[data-contact-creation-date], [data-contact-creation-date-iso]')) return;
      applyContactCreationDateFields(form);
    });

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;
        if (!form.querySelector('[data-contact-creation-date], [data-contact-creation-date-iso]')) return;
        applyContactCreationDateFields(form);
      },
      true
    );
  }

  function collapseEmptyHomepageSections() {
    if (!document.body.classList.contains('template-index')) return;

    var wrappers = document.querySelectorAll('.main-content .shopify-section');
    wrappers.forEach(function (wrapper) {
      var visibleChildren = Array.prototype.filter.call(wrapper.children, function (child) {
        var tag = child.tagName;
        return tag !== 'STYLE' && tag !== 'SCRIPT';
      });
      if (!visibleChildren.length) {
        wrapper.setAttribute('hidden', 'hidden');
      }
    });
  }

  function initRevealAnimations() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.tall-owl-section'));
    if (!sections.length) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (section) {
      section.setAttribute('data-tall-owl-reveal', 'true');
      if (reducedMotion) {
        section.classList.add('is-revealed');
      }
    });

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function applyModalAccessibility() {
    document.querySelectorAll('.modal').forEach(function (modal) {
      if (!modal.hasAttribute('role')) modal.setAttribute('role', 'dialog');
      if (!modal.hasAttribute('aria-modal')) modal.setAttribute('aria-modal', 'true');
    });
  }

  function initQuickSheetSwipeDismiss() {
    var active = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var content = event.target.closest('.tall-owl-quick-sheet .modal__centered-content');
        if (!content) return;
        if (content.scrollTop > 0) return;
        active = {
          content: content,
          startY: event.touches[0].clientY,
          deltaY: 0
        };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (!active) return;
        var y = event.touches[0].clientY;
        active.deltaY = Math.max(0, y - active.startY);
        if (active.deltaY > 0) {
          active.content.style.transform = 'translateY(' + Math.min(active.deltaY, 140) + 'px)';
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function () {
        if (!active) return;
        var content = active.content;
        var deltaY = active.deltaY;
        content.style.transform = '';
        if (deltaY > 80) {
          var modal = content.closest('.tall-owl-quick-sheet');
          var closeBtn = modal && modal.querySelector('.js-modal-close');
          if (closeBtn) closeBtn.click();
        }
        active = null;
      },
      { passive: true }
    );
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var product = event.detail && event.detail.product ? event.detail.product : null;
    var title = product && product.title ? product.title : 'Item';
    var productHandle = normalizeText(product && product.handle);
    var bogoConfig = getBogoSettings();
    var isBogoTrackedProduct =
      productHandle &&
      bogoConfig.enabled &&
      (bogoConfig.handleSet.has(productHandle) || (bogoConfig.freeHandleSet && bogoConfig.freeHandleSet.has(productHandle)));
    if (suppressNextAddToCartToast) {
      suppressNextAddToCartToast = false;
    } else if (!isBogoTrackedProduct) {
      showToast(title + ' added to cart.');
    }
    pushDataLayer('add_to_cart', { item_name: title });
  });

  document.addEventListener('quickview:open', function (event) {
    var productId = event.detail && event.detail.productId ? String(event.detail.productId) : '';
    pushDataLayer('quick_view_open', { product_id: productId });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVariantDescriptionBlocks(event && event.target ? event.target : document);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches('.tall-owl-newsletter__form') && !form.hasAttribute('data-klaviyo-form')) {
      pushDataLayer('newsletter_signup');
    }
  }, true);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.tall-owl-mobile-atc, .tall-owl-card-atc');
    if (btn) {
      event.preventDefault();
      if (btn.disabled) return;

      var previousText = (btn.textContent || '').trim() || 'Add to Cart';
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding...';

      addToCart(btn.getAttribute('data-variant-id'))
        .catch(function () {
          /* addToCart already handles user-facing error messaging */
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = previousText;
        });
      return;
    }

    var quickBuyButton = event.target.closest('[data-tall-owl-bogo-quick-buy]');
    if (quickBuyButton) {
      event.preventDefault();
      if (quickBuyButton.disabled || quickBuyButton.hidden) return;

      var bogoConfig = getBogoSettings();
      var productHandle = getQuickBuyButtonProductHandle(quickBuyButton);
      if (!bogoConfig.enabled || !productHandle || !bogoConfig.handleSet.has(productHandle)) return;

      var selectedVariantId = getQuickBuyButtonVariantId(quickBuyButton);
      if (!selectedVariantId) {
        showToast('Please select a valid variant first.');
        return;
      }

      var selectedQuantity = getQuickBuyButtonQuantity(quickBuyButton);
      var originalQuickBuyLabel = (quickBuyButton.textContent || '').trim() || 'Quick Buy';

      quickBuyButton.disabled = true;
      quickBuyButton.classList.add('is-loading');
      quickBuyButton.setAttribute('aria-busy', 'true');
      quickBuyButton.textContent = 'Preparing...';

      suppressNextAddToCartToast = true;
      addToCart(selectedVariantId, selectedQuantity)
        .then(function () {
          if (tallOwlBogoController && typeof tallOwlBogoController.flushSync === 'function') {
            return tallOwlBogoController.flushSync('quick-buy');
          }
          return Promise.resolve();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          suppressNextAddToCartToast = false;
          quickBuyButton.disabled = false;
          quickBuyButton.classList.remove('is-loading');
          quickBuyButton.removeAttribute('aria-busy');
          quickBuyButton.textContent = originalQuickBuyLabel;
        });
      return;
    }

    var landingCta = event.target.closest(
      '.tall-owl-hero__cta, .tall-owl-philosophy-problem__cta, .tall-owl-value__cta, .tall-owl-bestsellers__all-link, .tall-owl-routine__cta, .tall-owl-eye__cta, .tall-owl-bundle__cta, .tall-owl-final-cta__button, .tall-owl-live-reviews__load-more'
    );
    if (landingCta) {
      pushDataLayer('landing_cta_click', {
        cta_text: (landingCta.textContent || '').trim(),
        cta_href: landingCta.getAttribute('href') || ''
      });
    }

    var faqSummary = event.target.closest('.tall-owl-landing-faq__item summary');
    if (faqSummary) {
      window.setTimeout(function () {
        var item = faqSummary.closest('.tall-owl-landing-faq__item');
        if (item && item.open) {
          var label = faqSummary.querySelector('span');
          pushDataLayer('landing_faq_open', {
            question: label ? label.textContent.trim() : ''
          });
        }
      }, 0);
    }

    var sticky = event.target.closest('.tall-owl-sticky-cta__button');
    if (sticky) {
      pushDataLayer('sticky_cta_click');
      return;
    }

    var checkout = event.target.closest('button[name="checkout"], .cart__checkout');
    if (checkout) {
      pushDataLayer('begin_checkout');
    }
  });

  normalizeInputModes();
  initContactCreationDateFields();
  collapseEmptyHomepageSections();
  initRevealAnimations();
  initKlaviyoNewsletterForms();
  initCollectionGridRatings(document);
  initRotatingScentCards(document);
  initCollectionGridRatingsObserver();
  initVariantDescriptionBlocks(document);
  initVariantDescriptionObserver();
  initQuickSheetSwipeDismiss();
  initCartDrawerScrollReset();
  // ---------- Lightweight BOGO auto-add ----------
  // Shopify-native "Buy X Get Y" discounts handle pricing server-side.
  // Each paid product has a matching free clone product that Shopify
  // discounts to $0.  This listener adds the matching free product after
  // the customer adds a paid one — no checkout blocking, no sync
  // controller.  If the free-add fails the customer still checks out fine.
  (function initBogoAutoAdd() {
    var FREE_HANDLE_MAP = {
      'whipped-tallow': 'whipped-tallow-sca_clone_freegift',
      'tallow-trio-bundle': 'tallow-trio-bundle-sca_clone_freegift',
      'tallow-lip-balm': 'tallow-lip-balm-sca_clone_freegift',
      'tallow-body-balm': 'tallow-body-balm-sca_clone_freegift',
      'eye-serum': 'eye-serum-sca_clone_freegift'
    };

    var cartAddUrl = (window.theme && theme.routes && theme.routes.cartAdd)
      ? theme.routes.cartAdd
      : '/cart/add.js';

    function refreshCart() {
      return fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
    }

    function findMatchingVariant(freeProduct, paidVariantTitle) {
      var variants = freeProduct.variants || [];
      if (variants.length === 1) return variants[0].id;

      // Match by variant title (scent/size)
      var paid = (paidVariantTitle || '').toLowerCase().trim();
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].title || '').toLowerCase().trim() === paid) {
          return variants[i].id;
        }
      }

      // Fallback: first available variant
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available) return variants[j].id;
      }
      return variants.length ? variants[0].id : null;
    }

    document.addEventListener('ajaxProduct:added', function (event) {
      var product = event.detail && event.detail.product;
      if (!product) return;

      var handle = String(product.handle || product.product_handle || '').toLowerCase();
      var freeHandle = FREE_HANDLE_MAP[handle];
      if (!freeHandle) return;

      var paidVariantTitle = product.variant_title || '';

      // Fetch the free clone product to find the matching variant
      fetch('/products/' + encodeURIComponent(freeHandle) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (freeProduct) {
          var freeVariantId = findMatchingVariant(freeProduct, paidVariantTitle);
          if (!freeVariantId) return;

          return fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(freeVariantId), quantity: 1 })
          });
        })
        .then(function () { return refreshCart(); })
        .then(function () {
          showToast('BOGO applied \u2014 your free one\u2019s in there!');
        })
        .catch(function () {
          // Silent fail — customer keeps their item and checks out normally
        });
    });
  })();
  // ---------- End BOGO auto-add ----------

  // ---------- BOGO orphan cleanup ----------
  // When a paid product is removed, remove its free clone too.
  // Listens to cart:updated, checks for orphaned free items, removes them.
  (function initBogoOrphanCleanup() {
    var FREE_TO_PAID = {
      'whipped-tallow-sca_clone_freegift': 'whipped-tallow',
      'tallow-trio-bundle-sca_clone_freegift': 'tallow-trio-bundle',
      'tallow-lip-balm-sca_clone_freegift': 'tallow-lip-balm',
      'tallow-body-balm-sca_clone_freegift': 'tallow-body-balm',
      'eye-serum-sca_clone_freegift': 'eye-serum'
    };

    var cleaning = false;

    function cleanOrphans() {
      if (cleaning) return;
      cleaning = true;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var paidHandles = {};
          var orphanKeys = [];

          cart.items.forEach(function (item) {
            var h = (item.handle || '').toLowerCase();
            if (!FREE_TO_PAID[h]) {
              paidHandles[h] = true;
            }
          });

          cart.items.forEach(function (item) {
            var h = (item.handle || '').toLowerCase();
            var needsPaid = FREE_TO_PAID[h];
            if (needsPaid && !paidHandles[needsPaid]) {
              orphanKeys.push(item.key);
            }
          });

          if (!orphanKeys.length) {
            cleaning = false;
            return;
          }

          var updates = {};
          orphanKeys.forEach(function (key) { updates[key] = 0; });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function (r) { return r.json(); })
            .then(function (updatedCart) {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: updatedCart }
              }));
              document.dispatchEvent(new CustomEvent('cart:build'));
              cleaning = false;
            });
        })
        .catch(function () { cleaning = false; });
    }

    document.addEventListener('cart:updated', function () {
      setTimeout(cleanOrphans, 300);
    });
  })();
  // ---------- End BOGO orphan cleanup ----------

  // ---------- Size image filtering removed ----------
  // Image ordering + scent-based image sets handle everything natively.

  applyModalAccessibility();
})();
